import { render, staticRenderFns } from "./ChangeSelectionAppearance.vue?vue&type=template&id=0b3ca49c&"
import script from "./ChangeSelectionAppearance.vue?vue&type=script&lang=js&"
export * from "./ChangeSelectionAppearance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports